import React from 'react';

const TabButton = ({ service, selected, notifications, handleClick }) => {

  const notificationCount = notifications[service.id] ? notifications[service.id].length : 0;

  return (
    <button
      type="button"
      className={`service-tab p-3 ${selected ? "selected" : ""}`}
      onClick={() => handleClick(service)}
    >
      <div className="position-relative">
        <i className={`fa fa-lg ${service.fa_icon}`}></i>
        <p className="mb-0 smallish">
          {service.name}
        </p>
        {
          notificationCount > 0 ?
            <div className="notification-count">
              <span className='m-auto'>
                {notificationCount > 0 ? notificationCount : ""}
              </span>
            </div> : ""
        }
      </div>
    </button>
  )
}

export default TabButton;
